import {
  NOTIFICATION_EVENTS,
  NotificationStrategy,
  dispatchNotificationEvent,
  markAsAccepted,
  markNotificationAsResolved,
  markAsRejected,
} from '../../../../shared/services/notification/workflow';
import { resolveNpiSteeringDeletionDecision } from '../../../npi-steering/services/resolveNpiSteeringDeletionDecision';

async function handleAccept({ item }: Parameters<NotificationStrategy['accept']>[0]) {
  await resolveNpiSteeringDeletionDecision({
    item,
    decision: 'ACCEPT',
  });

  await markAsAccepted(item.userNotificationId, item.status);

  if (!item.notificationId) {
    console.error('[rowDeleteStrategy] accept:missing notificationMasterId', {
      item,
    });
    return;
  }

  await markNotificationAsResolved(item.notificationId);

  dispatchNotificationEvent(NOTIFICATION_EVENTS.DATA_REFRESH, {
    notificationId: item.notificationId,
    userNotificationId: item.userNotificationId,
    type: item.type,
    payload: item.payload,
  });
}

async function handleReject({ item }: Parameters<NotificationStrategy['reject']>[0]) {
  await resolveNpiSteeringDeletionDecision({
    item,
    decision: 'REJECT',
  });

  await markAsRejected(item.userNotificationId, item.status);

  if (!item.notificationId) {
    console.error('[rowDeleteStrategy] reject:missing notificationMasterId', {
      item,
    });
    return;
  }

  await markNotificationAsResolved(item.notificationId);

  dispatchNotificationEvent(NOTIFICATION_EVENTS.DATA_REFRESH, {
    notificationId: item.notificationId,
    userNotificationId: item.userNotificationId,
    type: item.type,
    payload: item.payload,
  });
}

export const rowDeleteStrategy: NotificationStrategy = {
  accept: handleAccept,
  reject: handleReject,
};
